import { render, staticRenderFns } from "./BannerTextColor.vue?vue&type=template&id=f1efd462&scoped=true&"
import script from "./BannerTextColor.vue?vue&type=script&lang=js&"
export * from "./BannerTextColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1efd462",
  null
  
)

export default component.exports